import React from "react";
import { useDispatch } from "react-redux";
import { showErrorMessage } from "../../actions";
import { IconButton, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import LocaleNumberField from "./LocaleNumberField";
import IconSearch from "@material-ui/icons/Search";

const ContractSearchField = ({ onNavigate }) => {
  const [searchId, setSearchId] = React.useState("");
  const dispatch = useDispatch();

  const handleNavigate = () => {
    if (!searchId) {
      dispatch(showErrorMessage("app.contract.searchId.empty"));
      return;
    }
    onNavigate(searchId);
  };

  return (
    <>
      <Typography
        variant="h6"
        paragraph
      >
        <FormattedMessage id="app.search" />
      </Typography>
      <LocaleNumberField
        label="app.search.contractId"
        value={searchId}
        setValue={setSearchId}
        decimalPlaces={0}
        checkEmptyError={false}
        fullWidth
        onKeyUp={(e) => e.key === "Enter" && handleNavigate()}
        endAdornment={
          <IconButton
            onClick={handleNavigate}
            size="small"
          >
            <IconSearch
              fontSize="small"
              color="primary"
            />
          </IconButton>
        }
      />
    </>
  );
};

export default ContractSearchField;
